import React from "react";
import {API, Auth, Storage} from "aws-amplify"
import BaseAdmin from "./BaseAdmin"
import CSVReader from 'react-csv-reader'
import {withRouter} from 'react-router-dom'
import {CSVLink} from 'react-csv'
import moment from 'moment'
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import InvoiceTable from '../../Components/Invoices/InvoiceTable'
import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    InputNumber,
    message, Modal,
    Row,
    Select,
    Spin,
    Table,
    Tooltip
} from "antd";
import definitions from "../../Util/AFIPdefinitions"
import locale from "antd/es/date-picker/locale/es_ES";

const {Option} = Select;
var interval = null
var count = 0

class UploadInvoices extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            step: 'batchList',
            loteIdView: null,
            nuevoLoteId: '',
            uploadingCsv: false,
            lastBatchId: null,
            lastUserId: null,
            lastInvoiceId: null,
            downloadedCSV: [],
            enableUpload: false,
            pagination: {},
            data: null,
            checkCuit: false,
            lote: [],
            csv: [],
            lotes: [],
            receptor: {
                nroDocumento: 0,
                razonSocial: '',
                tipoResponsable: 'iva-responsable-inscripto',
                domicilio: '',
                email: '',
                ciudad: '',
                provincia: '',
            },
            periodo: new Date().getMonth(),
            year: new Date().getUTCFullYear(),
            years: [new Date().getUTCFullYear() - 1, new Date().getUTCFullYear()],
            fechaInicio: null,
            fechaFin: null,
            fechaFactura: null,
            name: '',
            indexEditing: null,
            recordEditing: null,
            modalVisible: false,
            selectedKeys: [],

        }
        this.downloadZip = this.downloadZip.bind(this)
        this.createZip = this.createZip.bind(this)
        this.findZip = this.findZip.bind(this)
    }

    csvHeaders = [
        {
            label: 'CUIT emisor', title: 'CUIT emisor', key: 'cuit_emisor', dataIndex: 'cuit_emisor',
        },
        {
            label: 'Tipo de Factura', title: 'Tipo de Factura', key: 'tipo_factura', dataIndex: 'tipo_factura',
        },
        {
            label: 'Observaciones', title: 'Observaciones', key: 'observaciones', dataIndex: 'observaciones',
        },
        {
            label: 'Forma de pago', title: 'Forma de pago', key: 'forma_pago', dataIndex: 'forma_pago',
        },
        {
            label: 'Concepto 1', title: 'Concepto 1', key: 'concepto1', dataIndex: 'concepto1',
        },
        {
            label: 'Monto 1', title: 'Monto 1', key: 'monto1', dataIndex: 'monto1',
        },
        {
            label: 'Concepto 2', title: 'Concepto 2', key: 'concepto2', dataIndex: 'concepto2',
        },
        {
            label: 'Monto 2', title: 'Monto 2', key: 'monto2', dataIndex: 'monto2',
        },
        {
            label: 'Concepto 3', title: 'Concepto 2', key: 'concepto3', dataIndex: 'concepto3',
        },
        {
            label: 'Monto 3', title: 'Monto 3', key: 'monto3', dataIndex: 'monto3',
        },
        {
            label: 'Tipo Factura Asociada', title: 'Tipo Factura Asociada', key: 'tipo_factura_asociada', dataIndex: 'tipo_factura_asociada',
        },
        {
            label: 'Punto Venta', title: 'Punto Venta', key: 'punto_venta', dataIndex: 'punto_venta',
        },
        {
            label: 'Nro Factura Asociada', title: 'Nro Factura Asociada', key: 'factura_asociada', dataIndex: 'factura_asociada',
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record, index) => {
                return {
                    children: <>
                        <Button onClick={() => {
                            console.log(record);
                            this.setState({
                                modalVisible: true,
                                indexEditing: index,
                                recordEditing: record
                            })
                        }}>
                            Editar
                        </Button>
                    </>
                }
            }
        }
    ]

    componentDidMount() {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/batch',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        let batchs = response.batches.map(lote => {
                            lote['key'] = lote['batch_id']
                            lote['fechaLote'] = moment(lote['batch_id'] * 1000).format('YYYY-MM-DD hh:mm')
                            return lote
                        })
                        this.setState({loading: false, lotes: batchs})
                    })
                    .catch(err => console.log(err))
            })
    }

    componentWillUnmount() {
        if (interval !== null) {
            clearInterval(interval)
        }
    }

    handleCancelModal = () => {
        this.setState({modalVisible: false, modalBajarFacturasVisible: false})
    }

    saveEditing = () => {
        const csv = [...this.state.csv];
        csv[this.state.indexEditing] = this.state.recordEditing;
        const data = [...this.state.data];
        data[this.state.indexEditing] = this.state.recordEditing;
        this.setState({modalVisible: false, csv, data})
    }

    cuitData() {
        message.config({maxCount: 1})
        message
            .loading('Verificando CUIT...', 10)
        this.setState({checkCuit: false})
        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/contribuyente',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            cuit: this.state.receptor.nroDocumento
                        }
                    }
                )
                    .then(response => {
                        message.success('Cuit valido!')
                        this.setState({loading: false, enableUpload: true})
                        let razon_social = response["razonSocial"]
                        let direccion = response["Direccion"]
                        let ciudad = response['Localidad']
                        let provincia = response['Provincia']
                        this.updateData("domicilio", direccion)
                        this.updateData("razonSocial", razon_social)
                        this.updateData('provincia', provincia)
                        this.updateData('ciudad', ciudad)
                        this.props.form.setFieldsValue({
                            'numero-documento-cliente': this.state.receptor.nroDocumento,
                            'razon-social-cliente': razon_social,
                            'domicilio-comercial-cliente': direccion + '-' + ciudad + '-' + provincia
                        })

                    })
                    .catch(err => {
                        message.error("Cuit inexistente")
                        this.updateData("nroDocumento", null)
                        this.updateData("domicilio", null)
                        this.updateData("razonSocial", null)
                        this.updateData("ciudad", null)
                        this.updateData("provincia", null)
                        this.props.form.resetFields(['numero-documento-cliente', 'domicilio-comercial-cliente', 'razon-social-cliente'])
                        this.setState({loading: false})
                    })
            })
    }

    updateData(field, value) {
        const data = {...this.state.receptor}
        data[field] = value
        this.setState({receptor: data})
    }


    newBatch() {
        this.setState({step: 'newBatch', csv: []})
    }

    invoiceTable(batch_id) {
        this.setState({loteIdView: batch_id, step: 'batchView'})

    }


    async downloadBatch(batch_id) {
        let downloadedCSV = []
        this.setState({loading: true})
        try {
            let response = await Auth.currentSession();
            let queryStringParameters = {
                limit: 200
            }
            while (true) {
                let batch = await API.get(
                    'test',
                    '/root/batch/' + batch_id + '/invoices',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: queryStringParameters
                    }
                )
                if (batch.lastUserId !== null) {
                    queryStringParameters['lastUserId'] = batch.lastUserId
                    queryStringParameters['lastInvoiceId'] = batch.lastInvoiceId
                    batch.invoices.map(inv => {
                        downloadedCSV.push(inv)
                        return inv
                    })
                } else {
                    batch.invoices.map(inv => {
                        downloadedCSV.push(inv)
                        return inv
                    })
                    this.setState({downloadedCSV: downloadedCSV, loading: false, step: "csvDownloaded"})
                    break;
                }
            }
        } catch (err) {
            message.error('No se pudo leer el Lote')
        }
        this.setState({loading: false})
    }


    createZip(batch_id) {
        this.setState({loading: true})
        message.config({maxCount: 1})
        message
            .loading('Generando archivos pdf y comprimiendo...', 5)
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/pdf',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            batchId: batch_id
                        }
                    }
                )
                    .then(
                        interval = setInterval(this.findZip, 3000, batch_id)
                    )
                    .catch(e => {
                        message.error('No se pudo generar el archivo zip')
                        this.setState({loading: false})
                    })
            })
    }


    async findZip(batch_id) {

        try {
            const list = await Storage.list('invoicesBatchZip/')
            if (count < 8) {
                count = count + 1
                list.map(file => {
                        if (file.key === 'invoicesBatchZip/' + batch_id + '.zip') {
                            clearInterval(interval)
                            this.downloadZip(batch_id)
                        }
                        return null
                    }
                )
            } else {
                clearInterval(interval)
            }
        } catch (e) {
            console.log(e)
            this.setState({loading: false})
            clearInterval(interval)
            message.error('Archivo .zip no encontrado')
        }
    }

    async downloadZip(batch_id) {
        try {
            const zipFile = await Storage.get('invoicesBatchZip/' + batch_id + '.zip', {download: false})
            window.open(zipFile)
            this.setState({loading: false, step: 'batchList'})
        } catch (e) {
            console.log(e)
            message.error('No se pudo descargar el lote')
        }

    }


    emitirFacturas = async () => {
        this.setState({uploadingCsv: true})


        const response = await Auth.currentSession();
        let adminLites = await API.get(
            'test',
            '/root/admindashboard/adminlites/',
            {
                headers: {
                    Authorization: response.getIdToken().getJwtToken()
                }
            }
        ).catch(err => console.log(err));


        try {

            if (!adminLites) {
                adminLites = [];
            }

            let userId = '';
            adminLites.forEach(a => {
                if(a && a.cuit == this.state.receptor.nroDocumento) {
                    userId = a.user_id;
                }
            })

            const batchResponse = await API.post(
                'test',
                '/root/batch/admin/create',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    },
                    body: {
                        nroDocumento: this.state.receptor.nroDocumento,
                        razonSocialCliente: this.state.receptor.razonSocial,
                        domicilioComercialCliente: this.state.receptor.domicilio,
                        localidadCliente: this.state.receptor.ciudad,
                        provinciaCliente: this.state.receptor.provincia,
                        emailCliente: this.state.receptor.email,
                        tipoResponsable: this.state.receptor.tipoResponsable,
                        user_id: userId,
                        fecha_fin: moment(this.state.fechaFin).format('YYYY-MM-DD'),
                        fecha_inicio: moment(this.state.fechaInicio).format('YYYY-MM-DD'),
                        fecha_creacion: moment().format('YYYY-MM-DD'),
                        mes: meses[this.state.periodo] + ' ' + this.state.year,
                        name: this.state.name,
                        userId: userId,
                        groupuser: 'admin'
                    }
                }
            );
            this.setState({nuevoLoteId: batchResponse['batch_id']})
            this.uploadBatch(batchResponse['batch_id'])

        } catch (e) {
            message.error("Error creando lote en DB");
            console.error(e);
            this.setState({uploadingCsv: false})
        }
    }


    uploadBatch(batch_id) {
        const data = this.state.data.map(data => {
            data.fecha_factura = moment(this.state.fechaFactura || moment()).format('YYYY-MM-DD');
            data.servicio_fecha_vencimiento = moment(this.state.fechaFactura || moment()).format('YYYY-MM-DD');
            return data;
        })

        Storage.put('invoicesBatch/' + batch_id + '.csv', JSON.stringify(data), {
            level: 'public',
            contentType: 'text/csv'
        })
            .then(result => {
                message.success("Archivo CSV cargado con exito!")
                this.setState({uploadingCsv: false, step: 'batchList'})

            })
            .catch(err => {
                console.log(err)
                message.error('Error cargando archivo CSV')
                this.setState({uploadingCsv: false})
            });
    }

    handleCancel() {
        this.setState({loading: false, step: 'batchList', nuevoLoteId: null})
    }


    render() {
        const {getFieldDecorator} = this.props.form;

        const documentNumberValidator = (rule, value, callback) => {
            if (typeof (value) === 'undefined' || value === null || value === '') {
                callback('CUIT requerido');
            }

            value = value.toString().replace(/[-_]/g, "");
            if (value === '') {
                callback('CUIT requerido')
            } else if (value.length !== 11) {
                callback('El cuit debe tener 11 numeros')
            } else {
                var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                var total = 0;
                for (var i = 0; i < mult.length; i++) {
                    total += parseInt(value[i]) * mult[i];
                }
                var mod = total % 11;
                var digito = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;
            }
            if (digito === parseInt(value[10])) {
                this.setState({checkCuit: true})
                callback()
            } else {
                callback('CUIT invalido')
            }
        }

        if (this.state.loading) {
            return (
                <>
                    <Row></Row>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                    <Row></Row>
                </>
            )
        } else if (this.state.step === 'batchList') {

            let columns = [
                {
                    title: 'Fecha emision',
                    key: 'fechaLote',
                    dataIndex: 'fechaLote',
                    render: (value, row, index) => {
                        return {
                            children: moment(value).format("YYYY-MM-DD hh:mm")
                        }
                    },
                    sorter: (a, b) => moment(a.fechaLote).diff(b.fechaLote),
                    defaultSortOrder: 'descend'
                },
                {
                    title: 'CUIT destinatario',
                    key: 'nroDocumento',
                    dataIndex: 'nroDocumento'
                },
                {
                    title: 'Razon social destinatario',
                    key: 'razonSocialCliente',
                    dataIndex: 'razonSocialCliente'
                },
                {
                    title: 'Cantidad de Facturas',
                    key: 'total',
                    dataIndex: 'total'
                },
                {
                    title: 'Facturas Procesadas',
                    key: 'processed',
                    dataIndex: 'processed'
                },
                {
                    title: 'Facturas Aprobadas',
                    key: 'approved',
                    dataIndex: 'approved'
                },
                {
                    title: 'Acciones',
                    dataIndex: 'actions',
                    key: 'actions',
                    render: (text, record, index) => {
                        return {
                            children: <>
                                <Button onClick={() => this.invoiceTable(record.batch_id)}>
                                    Ver
                                </Button>
                                <Button icon="file-excel" onClick={() => this.downloadBatch(record.batch_id)}>
                                    CSV
                                </Button>
                                <Button icon="file-zip" onClick={() => this.createZip(record.batch_id)}>
                                    ZIP
                                </Button>
                            </>
                        }
                    }
                }
            ]

            return (
                <BaseAdmin
                    selected='facturador'>
                    <Row>
                        <Card title={'Lotes de Facturacion'}>
                            <Table
                                columns={columns}
                                dataSource={this.state.lotes}
                                scroll={{x: "max-content"}}
                                style={{margin: "20px"}}
                                loading={this.state.loading}
                                pagination={{
                                    showSizeChanger: true,
                                    pageSizeOptions: ['5', '10', '50'],
                                    defaultSizePage: 10,
                                    hideOnSinglePage: true
                                }}
                            />
                        </Card>
                        <Button style={{marginTop: 10, marginBottom: 10}} onClick={() => this.newBatch()}>Generar nuevo
                            Lote</Button>
                    </Row>
                </BaseAdmin>
            )

        } else if (this.state.step === 'batchView') {
            return (
                <BaseAdmin
                    selected='facturador'>
                    <InvoiceTable batchId={this.state.loteIdView}></InvoiceTable>
                    <Button type="primary" onClick={() => this.setState({step: 'batchList'})}
                            style={{marginTop: '10px'}}>Volver</Button>
                </BaseAdmin>)
        } else if (this.state.step === 'newBatch') {
            let loading = this.state.csv.reduce((acc, curr) => {
                return acc ? true : curr.estado === "Procesando"
            }, false)
            //let disabledProcess = (this.state.csv.length === 0 || this.state.csv.reduce((acc, curr) => { return acc ?  curr.estado !== "Sin procesar" : false }, true)) && !loading

            return (
                <BaseAdmin
                    selected="facturador"
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginBottom: 15,
                        alignItems: 'top'
                    }}>
                        <Card style={{marginRight: 15, flex: 1}} title={'Datos del Lote'}>
                            <Col>
                                <Form.Item label="Nombre">
                                    {
                                        getFieldDecorator('name', {
                                            value: this.state.name,
                                            rules: [
                                                {
                                                    required: false,
                                                }
                                            ],
                                            initialValue: ''
                                        })(
                                            <Input style={{width: 300}}
                                                   placeholder="Nombre"
                                                   onChange={(name) => this.setState({name: name.target.value})}
                                                   suffix={
                                                       <Tooltip title="Modificar nombre del lote">
                                                           <Icon type="info-circle"/>
                                                       </Tooltip>
                                                   }
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item label="Periodo">
                                    <div style={{display: 'flex', flexDirection: 'row'}}>
                                        {
                                            getFieldDecorator('periodo', {
                                                value: this.state.periodo,
                                                rules: [
                                                    {
                                                        required: true,
                                                    }
                                                ],
                                                initialValue: new Date().getMonth()
                                            })(
                                                <Select style={{width: 100}}
                                                        onChange={(value) => {
                                                            this.setState({periodo: value})
                                                        }}>
                                                    {Array.from({length: 12}, (_, i) => i + 1).map(value =>
                                                        <Option key={value}
                                                                value={value}>{meses[value]}</Option>)
                                                    }

                                                </Select>
                                            )
                                        }
                                        {getFieldDecorator('year', {
                                            value: this.state.year,
                                            rules: [
                                                {
                                                    required: true,
                                                }
                                            ],
                                            initialValue: this.state.year
                                        })(
                                            <Select style={{width: 100, marginLeft: 10}}
                                                    onChange={(value) => {
                                                        this.setState({year: value})
                                                    }}>
                                                <Option key={'y1'} value={this.state.years[0]}>{this.state.years[0]}
                                                </Option>
                                                <Option key={'y2'} value={this.state.years[1]}>{this.state.years[1]}
                                                </Option>
                                            </Select>
                                        )

                                        }
                                    </div>
                                </Form.Item>
                            </Col>
                            <Row gutter={8}>
                                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                    <Form.Item label="Servicio desde">
                                        {
                                            getFieldDecorator('fechaInicio', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Servicio desde requerido'
                                                }],
                                                value: this.state.fechaInicio,
                                                initialValue: null
                                            })(<DatePicker
                                                onChange={(date) => this.setState({fechaInicio: date})}
                                                format="DD-MM-YYYY"
                                                disabledDate={d => !d || d.isAfter(moment())}
                                                locale={locale}
                                                style={{width: 200}}
                                                allowClear={false}
                                            />)
                                        }
                                    </Form.Item>

                                    <Form.Item label="Servicio hasta" style={{marginLeft: 10}}>
                                        {
                                            getFieldDecorator('fechaFin', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Servicio hasta requerido'
                                                }],
                                                value: this.state.fechaFin,
                                                initialValue: null
                                            })(<DatePicker
                                                onChange={(date) => this.setState({fechaFin: date})}
                                                disabledDate={d => !d || d.isAfter(moment()) || d.isBefore(this.state.fechaInicio)}
                                                format="DD-MM-YYYY"
                                                locale={locale}
                                                style={{width: 200}}
                                                allowClear={false}
                                            />)
                                        }
                                    </Form.Item>
                                </div>
                            </Row>
                            <Col>
                                <Form.Item label="Fecha de factura">
                                    {
                                        getFieldDecorator('fechaFactura', {
                                            rules: [{
                                                required: false,
                                            }],
                                            value: this.state.fechaFactura,
                                            initialValue: null
                                        })(<DatePicker
                                            onChange={(date) => this.setState({fechaFactura: date})}
                                            disabledDate={d => !d || d.isAfter(moment()) || d.isBefore(moment().subtract(15, 'd'))}
                                            format="DD-MM-YYYY"
                                            locale={locale}
                                            style={{width: 200}}
                                            allowClear={true}
                                        />)
                                    }
                                </Form.Item>
                            </Col>
                        </Card>
                        <Card style={{flex: 1}} title={'Datos de Receptor de Facturas'}>
                            <Col>
                                <Form.Item label={'CUIT'}>
                                    {
                                        getFieldDecorator('numero-documento-cliente', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'CUIT requerido'
                                                },
                                                {
                                                    validator: documentNumberValidator
                                                }
                                            ]
                                        })(
                                            <InputNumber
                                                style={{width: '100%'}}
                                                onChange={(value) => this.updateData("nroDocumento", value ? value : null)}
                                                onBlur={() => {
                                                    if (this.state.checkCuit === true) {
                                                        this.cuitData()
                                                    }
                                                }}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item label={'Razón social'}>
                                    {
                                        getFieldDecorator('razon-social-cliente', {
                                            rules: [{
                                                required: false,
                                            }],
                                            value: this.state.receptor.razonSocial
                                        })(
                                            <Input
                                                disabled={true}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item label="Domicilio">
                                    {
                                        getFieldDecorator('domicilio-comercial-cliente', {
                                            value: this.state.receptor.domicilio,
                                            rules: [
                                                {
                                                    required: false,
                                                }
                                            ]
                                        })(
                                            <Input
                                                disabled={true}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item label="Tipo de Responsable">
                                    {
                                        getFieldDecorator('tipo_responsable', {
                                            value: this.state.receptor.tipoResponsable,
                                            rules: [
                                                {
                                                    required: true,
                                                }
                                            ],
                                            initialValue: "iva-responsable-inscripto"
                                        })(
                                            <Select
                                                onChange={(value) => this.updateData('tipoResponsable', value)}>
                                                {definitions.responsable.map(value => {
                                                    return (<Option key={value.value}
                                                                    value={value.value}>{value.name}</Option>)
                                                })}

                                            </Select>
                                        )
                                    }
                                </Form.Item>
                            </Col>

                        </Card>

                    </div>

                    <Row>
                        <Card>
                            <CSVReader
                                disabled={!this.state.enableUpload}
                                onFileLoaded={(data) => {
                                    const selectedKeys = [];
                                    let rows = data.map((value, index) => {
                                        value["key"] = index
                                        value['procesar'] = true;
                                        selectedKeys.push(index);
                                        return value
                                    })
                                    console.table(rows);
                                    this.setState({csv: rows, data: data, selectedKeys})
                                }}
                                parserOptions={{
                                    header: true,
                                    skipEmptyLines: true,
                                    transformHeader: header =>
                                        header
                                            .toLowerCase()
                                            .replace(/\W/g, '_')
                                }}
                                cssClass="ant-btn ant-btn-primary"
                                label="Importar CSV"
                                onError={() => {
                                    this.setState({csv: []})
                                    return (
                                        message.error('Error en archivo CSV')
                                    )
                                }}
                            />

                            <Modal
                                title={"Editar"}
                                width={700}
                                visible={this.state.modalVisible}
                                onOk={this.saveEditing}
                                onCancel={this.handleCancelModal}
                                footer={[
                                    <Button key="back" onClick={this.handleCancelModal}>
                                        Cancelar
                                    </Button>,
                                    <Button key="submit" type="primary" onClick={this.saveEditing}>
                                        Guardar
                                    </Button>,
                                ]}
                            >
                                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                    {this.state.recordEditing && this.csvHeaders.filter(c => c.label).map(c => (
                                        <div style={{marginTop: 5, marginRight: 10}}>
                                            <label>{c.label}</label><br/>
                                            <Input style={{width: 300}}
                                                   key={c.dataIndex}
                                                   value={this.state.recordEditing[c.dataIndex]}
                                                   onChange={e => {
                                                       const record = {...(this.state.recordEditing)};
                                                       record[c.dataIndex] = e.target.value;
                                                       this.setState({recordEditing: record})
                                                   }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </Modal>
                            <Table
                                columns={this.csvHeaders}
                                dataSource={this.state.csv}
                                rowClassName={(data, index) => data.procesar ? 'procesar' : 'no-procesar'}
                                rowSelection={{
                                    selectedRowKeys: this.state.selectedKeys,
                                    onChange: selectedKeys => this.setState({selectedKeys}),
                                    onSelect: record => {
                                        this.state.csv[record.key].procesar = !this.state.csv[record.key].procesar;
                                        this.setState({csv: [...this.state.csv]})
                                    }
                                }}
                                scroll={{x: "max-content"}}
                                style={{margin: "20px"}}
                            />
                            <Button.Group style={{marginTop: "15px", marginLeft: "15px"}}>
                                <Button
                                    type="primary"
                                    onClick={(e) => this.emitirFacturas()}
                                    loading={this.state.uploadingCsv}
                                    disabled={!this.state.enableUpload || !this.state.receptor.nroDocumento || !this.state.receptor.razonSocial || this.state.periodo == null || !this.state.fechaInicio || !this.state.fechaFin
                                    || (!this.state.csv)}
                                >
                                    Iniciar Facturacion
                                </Button>
                                <Button
                                    loading={loading}
                                    type="primary"
                                    disabled={false}
                                    onClick={() => this.handleCancel()}
                                >
                                    Volver
                                </Button>
                            </Button.Group>
                        </Card>
                    </Row>
                </BaseAdmin>
            );
        } else if (this.state.step === 'csvDownloaded') {

            let headerProcessed = [
                {
                    label: 'CUIT emisor',
                    title: 'CUIT emisor',
                    key: 'userCuit',
                    dataIndex: 'userCuit'

                },
                {
                    label: 'Razon Social emisor',
                    title: 'Razon social emisor',
                    key: 'razon_social',
                    dataIndex: 'razon_social'
                },

                {
                    label: 'Razon social cliente',
                    title: 'Razon Social',
                    key: 'razonSocialCliente',
                    dataIndex: 'razonSocialCliente'
                },
                {
                    label: 'Tipo Factura',
                    title: 'Tipo Factura',
                    key: 'tipoDeComprobante',
                    dataIndex: 'tipoDeComprobante'

                },
                {
                    label: 'Punto de Venta',
                    title: 'Punto de Venta',
                    key: 'puntoVenta',
                    dataIndex: 'puntoVenta'

                },
                {
                    label: 'Nro Comprobante',
                    title: 'Nro Comprobante',
                    key: 'nroDeComprobante',
                    dataIndex: 'nroDeComprobante'

                },
                {
                    label: 'Estado',
                    title: 'Estado',
                    key: 'estado',
                    dataIndex: 'estado'
                },
                {
                    label: 'Fecha de Comprobante',
                    title: 'Fecha de Comprobante',
                    key: 'fecha',
                    dataIndex: 'fecha'
                },
                {
                    label: 'Monto facturado',
                    title: 'Monto facturado',
                    key: 'importeTotal',
                    dataIndex: 'importeTotal'
                }
            ]
            return (
                <BaseAdmin>
                    <Button
                        loading={false}
                        type="primary"
                        disabled={false}
                    >
                        <CSVLink
                            data={this.state.downloadedCSV}
                            headers={headerProcessed}
                            filename={"Lote de facturacion " + this.state.downloadedCSV[0].batchId + ".csv"}
                            style={{marginLeft: '10px'}}
                        >
                            Descargar Lote en CSV
                        </CSVLink>
                    </Button>

                    <Button style={{marginLeft: "5px", marginRight: "5px"}}
                            onClick={() => this.setState({step: "batchList"})}>
                        Volver a tabla de Lotes
                    </Button>
                </BaseAdmin>
            )
        }
    }
}

const InvoiceBatch = Form.create({name: 'uploadInvoices'})(UploadInvoices)
export default withRouter(InvoiceBatch);

const meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', "Junio", 'Julio', "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];
